import apiHandler from "../apiHandler";

export const _addOrganization = async (formData: FormData) => {
  return apiHandler.post<any>("organizations", formData,'form');
};

export const _updateOrganization = async (formData: FormData) => {
  return apiHandler.put<any>("updateOrganization", formData,'form');
}

export const _deleteOrganization = async (organizationId: number) => {
  return apiHandler.delete("organizations/" + organizationId);
};